export const numberToPrintableValue = (value: number) =>
  value.toLocaleString('en-US').replaceAll(',', '');
